import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class CanDeactivateService {
    constructor() {
        this.canDeactivateList = [];
        this.refresh$ = new Subject();
        this.refresh$.subscribe(() => {
            this.canDeactivateList = [];
        });
    }
    registerCanDeactivate(canDeactivateFn, onDestroy) {
        this.refresh$
            .pipe(takeUntil(onDestroy))
            .subscribe(() => {
            this.canDeactivateList.push(canDeactivateFn());
        });
    }
    canDeactivate(promptUser = true) {
        this.refresh$.next();
        let canDeactivate = this.canDeactivateList.reduce((previousValue, currentValue) => {
            return previousValue && currentValue;
        }, true);
        if (canDeactivate)
            return true;
        if (promptUser) {
            return this.showWarning();
        }
        return canDeactivate;
    }
    showWarning() {
        return new Promise(resolve => {
            resolve(confirm('You have unsaved changes, would you like to Discard them?'));
        });
    }
}
CanDeactivateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanDeactivateService_Factory() { return new CanDeactivateService(); }, token: CanDeactivateService, providedIn: "root" });
